/** Role */
export const LOC_KEY_ROLE = "GUI-325062";

/** Uživatel */
export const LOC_KEY_USER = "GUI-650969";
